const ToggleSwitch = ({ label, checked, onChange, id }) => {
  const handleToggle = () => {
    onChange(!checked)
  }

  return (
    <div className="mt-3 flex items-center justify-end gap-2">
      <span id={`${id}-label`} className="site-label text-[11px]">
        {label}
      </span>
      <button
        type="button"
        id={id}
        role="switch"
        aria-checked={checked}
        aria-labelledby={`${id}-label`}
        onClick={handleToggle}
        className={[
          'site-toggle inline-flex h-5 w-9 shrink-0 items-center rounded-full border p-[2px] transition-colors duration-200',
          checked ? 'site-toggle-on' : 'site-toggle-off',
        ].join(' ')}
      >
        <span
          aria-hidden="true"
          className={[
            'site-toggle-thumb block h-3 w-3 shrink-0 rounded-full transition-transform duration-200 ease-in-out',
            checked ? 'translate-x-[1.125rem]' : 'translate-x-0',
          ].join(' ')}
        />
      </button>
    </div>
  )
}

export default ToggleSwitch
